import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatebusserviceinpune() {



const cardData = {
  keyword: " Corporate Bus Services in Pune  ",

"headingDescription": "SRS Cab Service offers Corporate Bus Services in Pune, providing safe, comfortable, and reliable transportation for employees and corporate teams. Whether it’s daily office shuttles, event transfers, or long-distance corporate travel, our well-maintained buses and professional drivers ensure timely and stress-free commutes. With flexible routes, transparent pricing, and 24/7 customer support, SRS Cab Service makes corporate travel in Pune efficient, convenient, and hassle-free.",
"topPlaces": [
  {
    "title": "Rajiv Gandhi Infotech Park",
    "description": "A major IT hub in Pune. Companies use SRS Cab Service corporate buses to transport employees efficiently to and from Rajiv Gandhi Infotech Park."
  },
  {
    "title": "Hinjewadi Phase 1 & 2",
    "description": "A key IT and corporate area. Corporate bus services from SRS Cab Service ensure safe and punctual commuting for employees."
  },
  {
    "title": "Magarpatta City",
    "description": "A prominent corporate and IT campus. Organizations rely on SRS Cab Service buses for daily employee transportation."
  },
  {
    "title": "EON IT Park",
    "description": "SRS Cab Service provides reliable corporate bus services for staff commuting to EON IT Park, ensuring comfort and timeliness."
  },
  {
    "title": "Kalyani Nagar",
    "description": "A residential and commercial hub. Corporate clients use SRS Cab Service buses for smooth commuting for office teams."
  },
  {
    "title": "Viman Nagar",
    "description": "An important business locality. Corporate bus services ensure employees reach offices in Viman Nagar comfortably and on time."
  },
  {
    "title": "Baner",
    "description": "A growing commercial and IT area. Companies rely on SRS Cab Service for corporate bus transport to and from Baner."
  },
  {
    "title": "Pimpri Chinchwad Industrial Area",
    "description": "Industrial and corporate offices use SRS Cab Service buses to manage employee transportation efficiently."
  },
  {
    "title": "Hadapsar",
    "description": "A fast-growing industrial and corporate hub. SRS Cab Service corporate buses provide timely and safe commuting for employees."
  },
  {
    "title": "Wakad",
    "description": "A residential and IT hub. Corporate bus services from SRS Cab Service ensure convenient daily travel for employees living in Wakad."
  }
],



services: [
{
name: "Corporate Bus Services in Pune",
description: "Corporate bus services in Pune offer reliable transportation for companies and large employee groups. Businesses can arrange daily staff travel. Professional drivers ensure safe journeys. Comfortable buses enhance experience. Flexible scheduling options are available. Travel easily with corporate bus services."
},
{
name: "Corporate Bus Service Pune",
description: "Corporate bus service Pune provides efficient travel solutions for business staff. Companies can book buses for daily commute. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible routes are available. Travel easily with corporate bus services."
},
{
name: "Pune Corporate Bus Service",
description: "Pune corporate bus service offers organized transport for employees and corporate teams. Businesses can manage staff travel easily. Professional drivers ensure safe journeys. Comfortable buses enhance experience. Flexible booking options are available. Travel easily with corporate bus services."
},
{
name: "Staff Bus Service Pune",
description: "Staff bus service Pune provides smooth and reliable travel for company employees. Businesses can arrange daily office transport. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible schedules are available. Travel easily with staff bus services."
},
{
name: "Employee Bus Service Pune",
description: "Employee bus service Pune offers convenient group transport for office staff. Companies can book buses for daily commute. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible routes are available. Travel easily with employee bus services."
},
{
name: "Office Bus Service Pune",
description: "Office bus service Pune provides dependable travel solutions for employees. Businesses can arrange daily pickup and drop services. Professional drivers ensure safe journeys. Comfortable buses enhance experience. Flexible timing options are available. Travel easily with office bus services."
},
{
name: "Company Bus Service Pune",
description: "Company bus service Pune offers organized transport for business employees. Companies can manage staff travel efficiently. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with company bus services."
},
{
name: "Corporate Bus Booking Pune",
description: "Corporate bus booking Pune provides easy reservation options for companies. Businesses can book buses anytime for employee transport. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with bus booking services."
},
{
name: "Corporate Bus Hire Pune",
description: "Corporate bus hire Pune offers flexible rental solutions for company transport. Businesses can book buses for daily and event travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible plans are available. Travel easily with bus hire services."
},
{
name: "Corporate Bus Rental Pune",
description: "Corporate bus rental Pune provides long-term and short-term transport solutions for companies. Businesses can arrange employee travel efficiently. Professional drivers ensure safe journeys. Comfortable buses enhance experience. Flexible booking options are available. Travel easily with bus rental services."
},
{
name: "Staff Transport Bus Service Pune",
description: "Staff transport bus service Pune offers reliable travel for office employees. Companies can arrange daily pickup and drop services. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible scheduling options are available. Travel easily with transport bus services."
},
{
name: "Employee Transport Bus Pune",
description: "Employee transport bus Pune provides group travel solutions for staff. Businesses can book buses for daily commute. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible routes are available. Travel easily with employee transport bus services."
},
{
name: "Office Staff Bus Service Pune",
description: "Office staff bus service Pune offers organized travel for company teams. Businesses can manage daily transport easily. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible schedules are available. Travel easily with staff bus services."
},
{
name: "Corporate Shuttle Service Pune",
description: "Corporate shuttle service Pune provides shared transport solutions for employees. Companies can arrange fixed routes and timings. Professional drivers ensure safe journeys. Comfortable buses enhance experience. Flexible plans are available. Travel easily with shuttle services."
},
{
name: "Company Bus Transport Pune",
description: "Company bus transport Pune offers reliable group travel for employees. Businesses can arrange daily and event transport. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with bus transport services."
},
{
name: "Corporate Bus Service Near Me Pune",
description: "Corporate bus service near me Pune helps businesses find nearby transport solutions quickly. Companies can book buses easily for staff. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with bus services."
},
{
name: "Corporate Travel Bus Pune",
description: "Corporate travel bus Pune offers comfortable transport for business trips and events. Companies can book buses for group travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with travel bus services."
},
{
name: "Corporate Group Transport Pune",
description: "Corporate group transport Pune provides efficient travel for large employee groups. Businesses can manage transport for teams easily. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible scheduling options are available. Travel easily with group transport services."
},
{
name: "Business Bus Service Pune",
description: "Business bus service Pune offers reliable transport for corporate employees and teams. Companies can book buses for daily commute. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with business bus services."
},
{
name: "Corporate Bus Service Provider Pune",
description: "Corporate bus service provider Pune offers complete transport solutions for companies. Businesses can outsource employee travel services. Professional drivers ensure safe journeys. Comfortable buses enhance experience. Flexible service plans are available. Travel easily with bus provider services."
},
{
name: "17 Seater Corporate Bus Pune",
description: "17 seater corporate bus Pune offers compact group travel for small teams. Companies can book buses for daily commute and trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with 17 seater bus services."
},
{
name: "25 Seater Corporate Bus Pune",
description: "25 seater corporate bus Pune provides medium group transport for employees. Companies can arrange daily staff travel easily. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with 25 seater bus services."
},
{
name: "32 Seater Corporate Bus Pune",
description: "32 seater corporate bus Pune offers spacious travel for larger employee groups. Businesses can book buses for office transport. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with 32 seater bus services."
},
{
name: "40 Seater Corporate Bus Pune",
description: "40 seater corporate bus Pune provides large group transport for corporate teams. Companies can arrange staff travel efficiently. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with 40 seater bus services."
}
],

tableData: [
["Corporate Bus Services in Pune","Corporate Bus Service Pune"],
["Pune Corporate Bus Service","Staff Bus Service Pune"],
["Employee Bus Service Pune","Office Bus Service Pune"],
["Company Bus Service Pune","Corporate Bus Booking Pune"],
["Corporate Bus Hire Pune","Corporate Bus Rental Pune"],
["Staff Transport Bus Service Pune","Employee Transport Bus Pune"],
["Office Staff Bus Service Pune","Corporate Shuttle Service Pune"],
["Company Bus Transport Pune","Corporate Bus Service Near Me Pune"],
["Corporate Travel Bus Pune","Corporate Group Transport Pune"],
["Business Bus Service Pune","Corporate Bus Service Provider Pune"],
["17 Seater Corporate Bus Pune","25 Seater Corporate Bus Pune"],
["32 Seater Corporate Bus Pune","40 Seater Corporate Bus Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Reliable Corporate Bus Services in Pune",
    WhyChoosedescription: "SRS Cab Service offers dependable corporate bus services in Pune for employee transportation, office commute, corporate events, and staff movement with well-maintained buses and professional drivers."
  },
  {
    WhyChooseheading: "Customized Employee Transport Solutions",
    WhyChoosedescription: "We provide fully customized corporate bus services with route planning, shift-based pickup, and flexible schedules tailored to your company’s transportation needs."
  },
  {
    WhyChooseheading: "24/7 Corporate Bus Availability",
    WhyChoosedescription: "Our corporate bus service operates 24/7 to support IT companies, BPOs, and industries with night shifts, early morning shifts, and continuous operations."
  },
  {
    WhyChooseheading: "Wide Range of Bus Options",
    WhyChoosedescription: "Choose from mini buses, 17–25 seater buses, 32 seater, 40 seater, and 50 seater AC buses depending on employee strength and travel requirements."
  },
  {
    WhyChooseheading: "GPS Tracking & Safety Features",
    WhyChoosedescription: "All buses are equipped with GPS tracking, ensuring real-time monitoring, route optimization, and enhanced safety for employees."
  },
  {
    WhyChooseheading: "Verified Drivers & Compliance",
    WhyChoosedescription: "Our drivers are background-verified, trained, and follow corporate safety protocols to ensure safe and disciplined transportation services."
  },
  {
    WhyChooseheading: "On-Time Pickup & Efficient Routing",
    WhyChoosedescription: "We ensure timely pickup and drop with optimized routes, reducing travel time and improving employee productivity."
  },
  {
    WhyChooseheading: "Trusted Corporate Bus Provider in Pune",
    WhyChoosedescription: "SRS Cab Service is trusted by corporates and IT companies in Pune for reliable, affordable, and high-quality corporate bus services."
  }
]
}

const faqData = [
  { 
    question: "Do you provide corporate bus services in Pune?", 
    answer: "Yes, SRS Cab Service offers reliable corporate bus services in Pune for employee transportation, office commute, and corporate travel needs with safe and efficient service." 
  },
  { 
    question: "Can corporate bus services be customized?", 
    answer: "Yes, we provide customized corporate bus solutions including route planning, shift-based scheduling, and dedicated buses based on company requirements." 
  },
  { 
    question: "Is corporate bus service available 24/7?", 
    answer: "Yes, our corporate bus services operate 24/7 to support IT companies, BPOs, and industries with flexible working hours." 
  },
  { 
    question: "What types of buses are available?", 
    answer: "We offer mini buses, 17–25 seater buses, 32 seater, 40 seater, and 50 seater AC buses for different group sizes and travel needs." 
  },
  { 
    question: "Do you provide GPS tracking in buses?", 
    answer: "Yes, all buses are equipped with GPS tracking systems for real-time monitoring and enhanced employee safety." 
  },
  { 
    question: "Are drivers trained and verified?", 
    answer: "Yes, all drivers are background-verified, trained, and experienced to ensure safe and professional corporate transport service." 
  },
  { 
    question: "Do you provide services in IT hubs like Hinjewadi and Kharadi?", 
    answer: "Yes, we provide corporate bus services across major IT hubs including Hinjewadi, Baner, Wakad, Kharadi, and Viman Nagar." 
  },
  { 
    question: "Is service available for large employee groups?", 
    answer: "Yes, we provide buses for small teams as well as large employee groups with flexible fleet options." 
  },
  { 
    question: "Are corporate bus services cost-effective?", 
    answer: "Yes, we offer affordable corporate bus services with transparent pricing and long-term cost-effective plans for businesses." 
  },
  { 
    question: "How can I book corporate bus service in Pune?", 
    answer: "You can book corporate bus service by contacting us directly. We provide quick onboarding and seamless setup for companies." 
  }
];

const testimonials = [
  {
    id: 1,
    name: "HR Manager - IT Company",
    feedback:
      "We have been using SRS corporate bus services for employee transport in Pune. The buses are well-maintained, drivers are professional, and service is always on time. Very reliable.",
    rating: 5
  },
  {
    id: 2,
    name: "Operations Head - Manufacturing Company",
    feedback:
      "Best corporate bus service in Pune. Their route management, punctuality, and safety measures are excellent. Highly recommended for employee transportation.",
    rating: 5
  }
];



















const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SRS Cab - Corporate Bus Services Pune",
  "description": "Reliable corporate bus services in Pune with SRS Cab. Book staff and employee buses for office travel, corporate shuttle, and group transport. 24/7 service with luxury, AC, and non-AC buses for corporate travel.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pune",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5204",
    "longitude": "73.8567"
  },
  "url": "https://www.srscabservice.com/corporate-bus-services-pune",
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 00:00-23:59",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1475"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune, Maharashtra"
  }
};










  return (
    <div>
      

<Helmet>
  <title>Corporate Bus Services in Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book reliable corporate bus services in Pune with SRS Cab. Staff and employee buses available for office travel, corporate shuttle, and group transport. Luxury, AC, and non-AC buses available 24/7." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/106.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatebusserviceinpune;